var file_upload_viewer_default = {
  "fontElementMap": "wXhVZ",
  "file_upload_container": "iJu2F",
  "file_upload_link": "CeZvg",
  "file_upload_error_container": "wGHlN",
  "file_upload_file_info": "_9R-G-",
  "file_upload_type_icon": "bzB-X",
  "file_upload_status_icon_container": "dZQbR",
  "file_upload_status_icon": "wCPkL",
  "file_upload_description": "M92H-",
  "file_upload_name_container": "BZzT6",
  "file_upload_name": "rG6gR",
  "file_upload_extension": "BwT7x",
  "file_loader_icon": "_2lQgm",
  "file_upload_icon_frame": "C7yOy",
  "file_upload_icon_background": "_6n-eX"
};
export {
  file_upload_viewer_default as default
};
//# sourceMappingURL=file-upload-viewer-scss.js.map
